import React, { memo } from "react";
import PropTypes from "prop-types";

/**
 * Edit boolean checkbox cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */

export const editBooleanCheckCell = ({ isValueChanged }) => {
  const EditBooleanCheckCell = (props) => {
    const { onChange, dataItem, field, tdProps, isInEdit } = props;

    const handleChange = (e) => {
      onChange({
        dataItem: dataItem,
        field: field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.checked,
      });
    };

    const handleClick = (e) => {
      e.target.parentElement.firstChild.click();
    };

    const value = dataItem[field] === null ? false : dataItem[field];
    let inputProps = {};
    if (!isInEdit) {
      inputProps.disabled = true;
    }

    return <td {...tdProps} className={`${tdProps.className} ${isValueChanged && isValueChanged(dataItem, field) ? "k-state-changed" : ""}`} tabIndex={0} >
      <input type="checkbox" checked={value} onChange={handleChange} {...inputProps} />
      <div className={"overlay"} onClick={handleClick}></div>
    </td>
  };

  EditBooleanCheckCell.propTypes = {
    onChange: PropTypes.func,
    dataItem: PropTypes.object,
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func,
  };

  return memo(EditBooleanCheckCell);
}
